import React, { useEffect, useState } from "react";
import { OverlayTrigger, Row } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import SoftBadge from "modules/common/SoftBadge";
import Coin from "assets/svgs/coin";
import { useParams } from "react-router-dom";
import useRewardDataStore from "modules/rewards_points/store";
import moment from "moment";
import { Select } from "antd";
import CalendarComponent from "./CalendarComponent";
import LatestOrder from "./LatestOrder";
import { fourPlaceHolder } from "modules/utilities/utility";
import { Modal, CloseButton } from "react-bootstrap";
import { Form, Input ,Button} from "antd";
import { get } from "lodash";

const { Option } = Select;

function RewardsPoints() {
  const [show, setShow] = useState(false);
  const [active, setActive] = useState("Streak History");
  const [defaultMonth, setDefaultMonth] = useState(new Date().getMonth() + 1);
  const [defaultYear, setDefaultYear] = useState(new Date().getFullYear());
  const [yearOption, setYearOption] = useState([]);
  const [monthOption, setMonthOption] = useState([]);
  const [dateNo, setDateNo] = useState(null);
  const [products, setProducts] = useState(null);
  const [showModal ,setShowModal]=useState(false);
  const [customAmountVisible, setCustomAmountVisible] = useState(false);
  const [isSubmitting ,setIsSubmitting]=useState(false);

  const [selectedStreakMasterId, setSelectedStreakMasterId] = useState("");

  const [form] = Form.useForm(); 

  const { id } = useParams();

  const getCustomStreakMasterId = () => {
    const customReward = addRewardData.find((reward) => reward.rewardCoins === 3000);
    return customReward ? customReward.streakMasterId : null; // Return null if not found
  };

  const handleRewardChange = (value) => {
    if (value === "custom") {
      setCustomAmountVisible(true);
      // Fetch or determine the streakMasterId dynamically
      const customStreakMasterId = getCustomStreakMasterId(); // Implement this function
      setSelectedStreakMasterId(customStreakMasterId);
    } else {
      setCustomAmountVisible(false);
      const selectedReward = addRewardData.find(
        (reward) => reward.rewardCoins.toString() === value
      );
      if (selectedReward) {
        setSelectedStreakMasterId(selectedReward.streakMasterId);
      }
    }
  };

  const { fetRewardsData, rewardsLoading, rewardsData ,addRewardData , fetchAddRewardsData ,fetchAfterAddRewardsData ,fetchSyncBalanceData } = useRewardDataStore();
  const [currentMonth, setCurrentMonth] = useState(new Date());

  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => {
    setShow(true);
  };

  const getMonthOptions = (defaultYear) => {
    const _monthOptions = [
      {
        label: "Jan",
        value: 1,
      },
      {
        label: "Feb",
        value: 2,
      },
      {
        label: "Mar",
        value: 3,
      },
      {
        label: "Apr",
        value: 4,
      },
      {
        label: "May",
        value: 5,
      },
      {
        label: "Jun",
        value: 6,
      },
      {
        label: "Jul",
        value: 7,
      },
      {
        label: "Aug",
        value: 8,
      },
      {
        label: "Sept",
        value: 9,
      },
      {
        label: "Oct",
        value: 10,
      },
      {
        label: "Nov",
        value: 11,
      },
      {
        label: "Dec",
        value: 12,
      },
    ];

    const currentMonth = new Date().getMonth() + 1;
    const filteredMonths = _monthOptions.filter(
      (month) => month.value <= currentMonth
    );

    setMonthOption(
      defaultYear === new Date().getFullYear() ? filteredMonths : _monthOptions
    );
  };

  useEffect(() => {
    getMonthOptions(defaultYear);
  }, [defaultYear]);

  const generateYearsArray = () => {
    const startYear = 2023;
    const endYear = new Date().getFullYear();

    const yearsArray = [];

    for (let year = startYear; year <= endYear; year++) {
      yearsArray.push({ label: year, value: year });
    }
    setYearOption(yearsArray);
  };

  useEffect(() => {
    if (id && show) {
      fetRewardsData(id, defaultYear, defaultMonth);
      generateYearsArray();
    }
  }, [id, defaultYear, defaultMonth, show]);

  const streakHistoryMapper = [
    {
      label: "Current Streak",
      value: `${rewardsData?.currentDaysStreakCount} Days`,
    },
    {
      label: "Longest Streak",
      value: `${rewardsData?.longestDaysStreakCount} Days`,
    },
    { label: "3 Days Streak", value: `${rewardsData?.threeDaysStreakCount}` },
    { label: "7 Days Streak", value: `${rewardsData?.sevenDaysStreakCount}` },
    {
      label: "21 Days Streak",
      value: `${rewardsData?.twentyOneDaysStreakCount}`,
    },
  ];

  useEffect(()=>{
    if(show){
      fetchAddRewardsData(); 
    }
  },[show]);



  const onFinish = async (values) => {
    try {
      setIsSubmitting(true);
      const reasonGiven = get(values, "reason", null);
      const formData = {
        reason: reasonGiven,
        streakMasterId: selectedStreakMasterId,
        customAmount: customAmountVisible ? values.customAmount : null,
      };
  
      await fetchAfterAddRewardsData(id, formData);
      await fetRewardsData(id, defaultYear, defaultMonth);
    } catch (error) {
      const errorMsg = get(error, "message", 'Unknown error');
      toast.error(`Failed to submit data: ${errorMsg}`);
    } finally {
      setShowModal(false);
      setCustomAmountVisible(false);
      setIsSubmitting(false);
    }
  };
  
  const clearForm = () => {
    form.resetFields();
    setCustomAmountVisible(false); 
    setSelectedStreakMasterId(""); 
  };
  const handleSyncBalance=async()=>{
   await fetchSyncBalanceData(id);
   await fetRewardsData(id, defaultYear, defaultMonth);
  }
  return (
    <>
      <div variant="primary" className="">
        <div className="d-flex">
          <OverlayTrigger
            overlay={
              <Tooltip
                style={{ position: "fixed" }}
                id="overlay-trigger-example"
              >
                <div className="fw-bold">Build A Habit - Reward Coins</div>
              </Tooltip>
            }
          >
            <div
              className="d-flex text-primary cursor-pointer"
              onClick={handleShow}
            >
              <Coin width={34} height={35} />
            </div>
          </OverlayTrigger>
        </div>
      </div>
      <Offcanvas
        show={show}
        onHide={handleClose}
        style={{ width: "45%" }}
        placement="end"
        {...rewardsData}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div style={{  display: "flex", justifyContent: "space-between", alignItems: "center", margin: 0, width: "100%" ,gap:"30px" }}>
              <div className="">
                <span className="text-primary fw-bold"  style ={{ textTransform :"uppercase"}}>
                  Build a Habit 
                </span>
              </div>
              <div>
              <Button  variant="filled"  disabled={!rewardsData?.isBalanceSyncingRequired} onClick={handleSyncBalance} className="w-max ">
             Sync Balance
            </Button>
              </div>
            </div>
            <div className="pt-4">
                <span className="text-primary fw-bold">
                 Reward Coins -(
                  {rewardsData?.rewardBalance})
                </span>
                <div className="text-primary fw-bold">
                ShopFlo Coins - (
                  {rewardsData?.shopFloCoins===null ? "0" : rewardsData?.shopFloCoins })
                </div>
               
              </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {rewardsLoading ? (
            fourPlaceHolder()
          ) : (
            <div>
              <Row>
                <div style={{ display: "flex", gap: "10px" }}>
                  <Select
                    dropdownStyle={{ minWidth: "15rem" }}
                    options={monthOption}
                    onChange={(e) => {
                      setDefaultMonth(e);
                      setCurrentMonth(
                        new Date(currentMonth.getFullYear(), e - 1, 1)
                      );
                      setDateNo(null);
                      setProducts(null);
                    }}
                    placeholder="Month"
                    defaultValue={monthOption.find(
                      (e) => e.value === defaultMonth
                    )}
                  />
                  <Select
                    dropdownStyle={{ minWidth: "15rem" }}
                    options={yearOption}
                    onChange={(e) => {
                      setDefaultYear(e);
                      setCurrentMonth(new Date(e, currentMonth.getMonth(), 1));
                      setDateNo(null);
                      setProducts(null);
                    }}
                    placeholder="Year"
                    defaultValue={yearOption.find(
                      (e) => e.value === defaultYear
                    )}
                  />
                  {rewardsData?.isUserAuthorizedToGiveCoins &&
                    <Button style={{ height: "2.6rem" }} onClick={()=>setShowModal(true)} className="me-n1" type="primary">Add Rewards</Button>} 
                   <Modal show={showModal} fullscreen="sm-down" onHide={() => setShowModal(false)}>
        <Modal.Header>
          <Modal.Title>Add Rewards</Modal.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={() => setShowModal(false)}
          />
        </Modal.Header>
        <Modal.Body>
          <div className="grid gap-1 justify-items-center">
          <Form layout="vertical" onFinish={onFinish}>
          {/* Reason Field */}
          <Form.Item
            label="Enter the Reason"
            name="reason"
            rules={[{ required: true, message: "Please enter the reason" }]}
          >
            <Input 
                 placeholder="Reason for reward"
                 onKeyPress={(e) => {
      if (/\d/.test(e.key)) {
        e.preventDefault(); // Prevent the default action if it's a number
      }
    }}
                  />
          </Form.Item>

          {/* Reward Selection Field */}
          <Form.Item
            label="Select Reward"
            name="reward"
            rules={[{ required: true, message: "Please select a reward" }]}
          >
               <Select placeholder="Select a reward" onChange={handleRewardChange}>
              {addRewardData.map((reward) => (
                <Option key={reward?.streakMasterId} value={reward?.rewardCoins.toString()}>
                  {reward?.rewardCoins}
                </Option>
              ))}
              <Option value="custom">Custom Amount</Option>
            </Select>
          </Form.Item>

          {/* Custom Amount Field - Conditional */}
          {customAmountVisible && (
            <Form.Item
              label="Custom Amount"
              name="customAmount"
              rules={[
  { required: true, message: "Please enter a custom amount" },
  { 
    validator: (_, value) => {
      if (value === undefined || value === '') {
        return Promise.resolve();
      }
      const numValue = Number(value);
      if (isNaN(numValue)) {
        return Promise.reject(new Error("Please enter a valid number"));
      }
      if (numValue > 6000) {
        return Promise.reject(new Error("Amount must be less than or equal to 6000"));
      }
      return Promise.resolve();
    }
  }
]}
            >
              <Input placeholder="Enter custom amount"   type="text"   
             onKeyPress={(e) => {
            // Allow only numbers
            if (!/[0-9]/.test(e.key)) {
              e.preventDefault(); // Prevent any non-numeric character
            }
          }}
          onChange={(e) => {
            const value = parseInt(e.target.value, 10); // Parse the input value to an integer
            if (value > 6000) {
              form.setFields([
                {
                  name: 'customAmount',
                  errors: ['Amount must be less than or equal to 6000'],
                },
              ]);
            } else {
              // Clear any previous errors if value is within limits
              form.setFields([{ name: 'customAmount', errors: [] }]);
            }
          }}
    
    />
            </Form.Item>
          )}

        {/* Submit and Clear Buttons */}
          <Form.Item >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: 0, width: "100%" }}>
          <Button type="primary" htmlType="submit" className="w-max mt-2" disabled={isSubmitting}>
              {isSubmitting ? "Submitting...":"Submit"}
            </Button>
            <Button  onClick={clearForm} className="w-max mt-2 ml-2">
              Clear
            </Button>
          </div>

          </Form.Item>

        </Form>
          </div>
        </Modal.Body>
      </Modal>
                </div>
              </Row>
              <Row>
                <div
                  style={{ width: "100%", overflowX: "auto", marginTop:"30px" }}
                  className="p-2 d-flex align-items-center"
                >
                  {active === "Streak History" ? (
                    <SoftBadge className="p-3" style={{ minWidth: "14rem" }}>
                      Streak History
                    </SoftBadge>
                  ) : (
                    <p
                      style={{ minWidth: "5rem" }}
                      className="m-0 p-2 rounded cursor-pointer"
                      onClick={() => {
                        setActive("Streak History");
                      }}
                    >
                      Streak History
                    </p>
                  )}

                  {active === "Reward History" ? (
                    <SoftBadge className="p-3" style={{ minWidth: "14rem" }}>
                      Reward History
                    </SoftBadge>
                  ) : (
                    <p
                      style={{ minWidth: "5rem" }}
                      className="m-0 p-2 rounded cursor-pointer"
                      onClick={() => {
                        setActive("Reward History");
                      }}
                    >
                      Reward History
                    </p>
                  )}

                  {active === "Reward Activity Log" ? (
                    <SoftBadge className="p-3" style={{ minWidth: "14rem" }}>
                      Reward Activity Log
                    </SoftBadge>
                  ) : (
                    <p
                      style={{ minWidth: "5rem" }}
                      className="m-0 p-2 rounded cursor-pointer"
                      onClick={() => {
                        setActive("Reward Activity Log");
                      }}
                    >
                      Reward Activity Log
                    </p>
                  )}

                  {active === "Latest Medicines" ? (
                    <SoftBadge className="p-3" style={{ minWidth: "14rem" }}>
                      Latest Medicines
                    </SoftBadge>
                  ) : (
                    <p
                      style={{ minWidth: "5rem" }}
                      className="m-0 p-2 rounded cursor-pointer"
                      onClick={() => {
                        setActive("Latest Medicines");
                      }}
                    >
                      Latest Medicines
                    </p>
                  )}
                </div>
                <div
                  style={{ width: "100%", overflowX: "auto" }}
                  className="p-2 d-flex align-items-center justify-content-center"
                >
                  {active === "Streak History" && (
                    <div className="streak-container w-100 fs-2">
                      {streakHistoryMapper.map((streak) => {
                        return (
                          <>
                            <div className="py-2">
                              <SoftBadge
                                bg="primary"
                                className="w-100 text-wrap word-break"
                              >
                                <div className="px-2 py-2 d-flex justify-content-between">
                                  <span>{streak.label}</span>{" "}
                                  <span>{streak.value}</span>
                                </div>
                              </SoftBadge>
                            </div>
                          </>
                        );
                      })}
                    </div>
                  )}

                  {active === "Reward History" && (
                    <div
                      style={{ width: "100%", overflowX: "auto" }}
                      className="p-2 d-flex flex-column justify-content-center flex-nowrap scrollable-container"
                    >
                      <div className="d-flex flex-column">
                        <span className="fw-medium fs-2">Balance</span>
                        <p className="fw-bold fs-1 d-flex">
                          <Coin width={15} height={16} />
                          <span
                            style={{
                              marginLeft: "5px",
                            }}
                          >
                            {rewardsData?.rewardBalance}
                          </span>
                        </p>
                      </div>
                      <p className="fw-bold fs-2">Transactions</p>
                      {rewardsData?.rewardHistory?.length > 0 &&
                        rewardsData?.rewardHistory.map((r, i) => {
                          return (
                            <div
                              className="py-2 w-100 d-flex gap-2 flex-wrap justify-content-center w-100 align-items-center"
                              key={i}
                            >
                              <SoftBadge
                                bg="primary"
                                className="w-100 text-wrap word-break"
                              >
                                <div className="w-100 d-flex justify-content-between align-items-center">
                                  <div
                                    className="d-flex flex-column justify-content-sm-start"
                                    style={{ fontSize: 13 }}
                                  >
                                    <span className="text-sm-start">
                                      {r?.remarks}
                                    </span>
                                    <span className="text-sm-start py-1 text-grey fw-normal">
                                      {moment(r?.txnDate).format("DD-MM-YY")}
                                    </span>
                                    <span className="text-sm-start py-1 text-danger fw-normal fs-sm--2 ">
                                      Expiring on{" "}
                                      {moment(r?.expiryDate).format("DD-MM-YY")}
                                    </span>
                                  </div>
                                  {r?.txnType === "Credit" ? (
                                    <div
                                      style={{ fontSize: 13 }}
                                      className="d-flex gap-1 text-success"
                                    >
                                      <span>+</span>{" "}
                                      <Coin width={13} height={14} />{" "}
                                      <span>{r?.txnCoinAmount}</span>
                                    </div>
                                  ) : (
                                    <div
                                      style={{ fontSize: 13 }}
                                      className="d-flex gap-1 text-danger"
                                    >
                                      <span>-</span>{" "}
                                      <Coin width={13} height={14} />{" "}
                                      <span>{r?.txnCoinAmount}</span>
                                    </div>
                                  )}
                                </div>
                              </SoftBadge>
                            </div>
                          );
                        })}
                    </div>
                  )}

                  {active === "Reward Activity Log" && (
                    <>
                      <CalendarComponent
                        currentMonth={currentMonth}
                        rewardsActivityLogs={rewardsData?.activityLogs}
                        setDateNo={setDateNo}
                        dateNo={dateNo}
                        products={products}
                        setProducts={setProducts}
                        rewardsActivityLogsTime={rewardsData?.activityLogTime}
                        // isNoActivityLog={Object.values(
                        //   rewardsData?.activityLogs
                        // ).every((arr) => Array.isArray(arr) && arr.length === 0)}
                      />
                    </>
                  )}
                  {active === "Latest Medicines" && (
                    <div>
                      <div>
                        <LatestOrder rewardsData={rewardsData} />
                      </div>
                    </div>
                  )}
                </div>
              </Row>
            </div>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default RewardsPoints;
